import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import {
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  DefaultSettingsService,
  EnvironmentConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  SettingsService,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  { provide: SettingsService, useClass: DefaultSettingsService },
];
